import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Input } from 'antd';

// Actions
import { onInviteNewResident, onInviteNewResidentModalIsShown } from '../../../data/homes/actions';

// Constants
import { MODAL_SIZES } from '../../../constants/modal';

class InviteUserModal extends PureComponent {
    handleSubmit = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const { msgs, onInviteNewResident, params } = this.props;
            onInviteNewResident(values.email, params).catch(() => {
                form.setFieldsValue({
                    hasError: msgs.homes.addHomeError
                });
            });
        });
    };

    handleCancel = () => {
        const { onInviteNewResidentModalIsShown } = this.props;
        onInviteNewResidentModalIsShown(false);
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const { form, isShown, isLoading, msgs } = this.props;

        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.homes.addHomeResident}
                onCancel={this.handleCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.invite}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.userEmail}>
                                    {getFieldDecorator('email', {
                                        initialValue: undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="email" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isShown: state.homes.getIn(['detail', 'users', 'inviteModal', 'isShown']),
        isLoading: state.homes.getIn(['detail', 'users', 'inviteModal', 'isLoading'])
    }),
    {
        onInviteNewResident,
        onInviteNewResidentModalIsShown
    }
)(Form.create()(InviteUserModal));
